import i18next from 'i18next'

// Shared singleton used across apps and packages.
export const coreI18n = i18next

export default coreI18n
export class useTranslation {}
